import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'home',
    templateUrl: 'home.component.html',
    styleUrls: ["home.component.scss"]
})

export class HomeComponent {
    title = "";
    subtitle = "";
    constructor(private route: Router) {

    }

    navigate(url: string) {
        this.route.navigate([url]);
      }
}